<template>
  <h1 class="timer-date">
    <span v-if="hasDate">{{ date.text }} </span>
    <span v-if="hasHours">
      <span>{{ date.hours[0] }}</span>
      <span>{{ date.hours[1] }}</span>
      <span>:</span>
      <span>{{ date.minutes[0] }}</span>
      <span>{{ date.minutes[1] }}</span>
    </span>
  </h1>
</template>

<script>
import { utils } from "@/util";
export default {
  data() {
    return {
      date: {
        text: "",
        hours: ["", ""],
        minutes: ["", ""],
      },
      setRefreshDate: "",
    };
  },
  props: {
    hasDate: {
      type: Boolean,
      default: true,
    },
    hasHours: {
      type: Boolean,
      default: true,
    },
    dateTime: {
      type: String,
      default: "",
    },
  },
  created() {
    if (this.dateTime === "") {
      this.refreshDate();
      this.setRefreshDate = setInterval(() => {
        this.refreshDate();
      }, 15000);
    } else {
      this.setDynamicDate();
      this.setRefreshDate = setInterval(() => {
        this.setDynamicDate();
      }, 15000);
    }
  },
  methods: {
    refreshDate() {
      let newDate = utils.getCurrentTimeNow();
      this.date = {
        text: newDate.format("dddd DD MMMM YYYY"),
        hours: newDate.format("HH").split(""),
        minutes: newDate.format("mm").split(""),
      };
    },
    setDynamicDate() {
      let newDate = utils.getDateFromString(this.dateTime, "YYYY-MM-DD");
      this.date = {
        text: newDate.format("dddd DD MMMM YYYY"),
        hours: utils.getCurrentTimeNow().format("HH").split(""),
        minutes: utils.getCurrentTimeNow().format("mm").split(""),
      };
    },
  },
  watch: {
    dateTime(newVal) {
      console.log("dateChange", newVal)
      if (newVal !== "") {
        sessionStorage.setItem("customDateTime", newVal);
        clearInterval(this.setRefreshDate);
        this.setDynamicDate();
        this.setRefreshDate = setInterval(() => {
          this.setDynamicDate();
        }, 15000);
      }
    },
  },
};
</script>

<style>
.timer-date {
  text-transform: capitalize;
}
</style>
